export type PersonName = {
  first_name?: string | null
  last_name?: string | null
  email: string
}

export function personDisplayName(person: PersonName) {
  const name = [person.first_name, person.last_name].filter(Boolean).join(" ").trim()
  return name || person.email
}

export function personInitials(person: PersonName) {
  const first = person.first_name?.trim()?.[0]
  const last = person.last_name?.trim()?.[0]
  if (first && last) return `${first}${last}`.toUpperCase()
  if (first) return first.toUpperCase()
  return person.email.trim().slice(0, 2).toUpperCase() || "•"
}
